import { NavigateOptions, useNavigate } from 'react-router-dom';

const useAppNavigate = () => {
  const navigator = useNavigate();

  return (
    route: any,
    options: NavigateOptions = {
      state: history?.state?.usr ? history?.state?.usr : { hfsPortal: true },
      replace: true,
    },
  ) => {
    navigator(route, options);
  };
};

export default useAppNavigate;
